import { Card } from "@blueprintjs/core";
import type { ExtraFieldTypeBox } from "@package/ui-gql/index-data-access";
import { useMemo } from "react";
import { isConditionFalsey } from "../service-data-form-utils";
import { ServiceDataFormField } from "../ServiceDataFormField";
import type { ServiceDataFormFieldBaseProps } from "./ServiceDataFormFieldEmpty";

type ServiceDataFormFieldBoxProps = ServiceDataFormFieldBaseProps & {
  field: ExtraFieldTypeBox;
};

function ServiceDataFormFieldBoxContent({
  data,
  field,
  onSourceChanged,
}: ServiceDataFormFieldBoxProps) {
  const disabled = useMemo<boolean>(
    () => !!field.condition && isConditionFalsey(field.condition, data),
    [data, field.condition],
  );

  if (disabled) {
    return null;
  }

  return (
    <Card className="mb-4">
      {field.extraFields.map((child, index) => {
        return (
          <ServiceDataFormField
            key={index}
            field={child}
            data={data}
            onSourceChanged={onSourceChanged}
          />
        );
      })}
    </Card>
  );
}

export function ServiceDataFormFieldBox({
  field,
  onSourceChanged,
  data,
}: ServiceDataFormFieldBaseProps) {
  if (field.__typename === "ExtraFieldTypeBox") {
    return (
      <ServiceDataFormFieldBoxContent
        field={field}
        data={data}
        onSourceChanged={onSourceChanged}
      />
    );
  }

  return null;
}
